<template lang="pug">
.crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
  modal-import(model="purchase_orders")
  modal-purchase-orders(:form='form', :is-add='isModalAdd')
  modal-summary-order(:form="form")
  modal-send-purchase-order(:form="form")
  modal-cancel-purchase-order(:form="form")
  .container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        div
          h2 {{ $t('strings.purchase_orders') }}:
          span {{ $t('strings.description', {attribute: $t('strings.purchase_orders')}) }}
        div(style="display:none;")
          vm-button(type="default" icon="list")
          vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
        div
          vm-tooltip(:text="$t('strings.options')" delay=".5s")
            vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
              vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(@click="exportRecords")
                  vm-icon(icon="download-outline")
                  slot &nbsp;{{ $t('strings.export') }}
                vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordsConfirm" :disabled="!enabledDelete")
                  vm-icon(icon="trash-2-outline")
                  slot &nbsp;{{ $t('strings.delete') }}
                //- More options
                    Agrega mas acciones para colecciones de datos
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(multiple v-model="selected"  max-height="350px" :data="purchaseOrders" )
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
              .d-flex.justify-content-between
                vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                  vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline" size="small")

                    vm-dropdown-menu(class="filters")
                      .heading.d-flex.justify-content-between
                        h4 {{ $t('strings.filters') }}
                        vm-button(type="flat" size="small" @click="eraseFilters") {{ $t('strings.clear') }}
                      vm-date-picker.filter(type="daterange" :label="$t('purchase_orders.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                      type-ahead-select-filter.filter_type_ahead(:title="$t('purchase_orders.suppliers')" :data="suppliersFilter" :defaultValue="supplierFilter" showColumn="name" @item-select="setSupplier" @search="searchSupplier" @deselect="deselectSupplier")
                      type-ahead-select-filter.filter_type_ahead(:title="$t('purchase_orders.projects')" :data="projectsFilter" :defaultValue="projectFilter" showColumn="name" @item-select="setProject" @search="searchProject" @deselect="deselecProject")
                      .filter.d-flex
                        vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('purchase_orders.'+ item)")
                  vm-order-by-item(value='folio,asc' text='Folio' direction='down')
                  vm-order-by-item(value='folio,desc' text='Folio' direction='up')
                  vm-order-by-item(value='created_at,asc' text='Creado el' direction='down')
                  vm-order-by-item(value='created_at,desc' text='Creado el' direction='up')
                vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                  vm-button(type="default" size="small" icon="list" style="display: none;")
                vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                  vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
          template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columns") {{ $t('purchase_orders.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                .details(@click="detailsPurchase(data[indextr])")
                  slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                  slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                  slot(v-if="column == 'freight'")  {{data[indextr][column] == 1 ? 'Si' : 'No'}}
                  slot(v-if="column == 'currency'")  {{data[indextr]['currency']['code']}}
                  slot(v-if="column != 'status' && column != 'created_at' && column != 'currency' && column != 'freight' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{ $t('purchase_orders.'+ data[indextr]['status']) }}
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr['status']] != 'sended' && data[indextr]['status'] != 'cancelled'" @click="editRecord(data[indextr], tr)")
                    vm-icon(icon="edit-2-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] === 'authorized'" @click="showSendPurchaseOrderModal(data[indextr], tr)")
                    vm-icon(icon="email-outline")
                    slot &nbsp;{{ $t('purchase_orders.send_order') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] != 'authorized' && data[indextr]['status'] != 'completed' && data[indextr]['status'] != 'cancelled'" @click="setActionRecord(data[indextr], 'authorize')")
                    vm-icon(icon="checkmark-circle-outline")
                    slot &nbsp;{{ $t('purchase_orders.authorize_order') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] != 'cancelled'" @click="showCancelPurchaseOrderModal(data[indextr], tr)")
                    vm-icon(icon="slash-outline")
                    slot &nbsp;{{ $t('purchase_orders.cancel_order') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] != 'cancelled'" @click="onReceptions(data[indextr])")
                    vm-icon(icon="home-outline")
                    slot &nbsp;{{ $t('strings.receptions') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] === 'Inactivo'" @click="deleteRecordConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  //- More actions
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
        transition(name="enter")
          .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'PurchaseOrders',
  components: {
    ModalImport: () => import('@/components/modals/ModalImport.vue'),
    ModalPurchaseOrders: () => import('@/components/modals/ModalPurchaseOrders.vue'),
    ModalSummaryOrder: () => import('@/components/modals/ModalSummaryOrder.vue'),
    ModalSendPurchaseOrder: () => import('@/components/modals/ModalSendPurchaseOrder'),
    ModalCancelPurchaseOrder: () => import('@/components/modals/ModalCancelPurchaseOrder'),
    TypeAheadSelectFilter: () => import('@/components/aditionals/TypeAheadSelectFilter.vue')
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: [
      'id',
      'folio',
      'project_display',
      'supplier_display',
      'email',
      'currency',
      'tax_type',
      'shipping_address',
      'delivery_time',
      'deadline',
      'freight',
      'justify',
      'notes',
      'status',
      'user_display',
      'created_at'
    ],
    columnsOrderBy: ['folio', 'created_at'],
    attributeModal: 'folio',
    status: [
      {
        value: 'pending',
        color: 'primary'
      },
      {
        value: 'sended',
        color: '#0000ff'
      },
      {
        value: 'completed',
        color: 'success'
      },
      {
        value: 'cancelled',
        color: 'danger'
      },
      {
        value: 'partially_stocked',
        color: '#00c4ff'
      },
      {
        value: 'authorized',
        color: 'success'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        folio: '',
        param: ''
      },
      whereIn: {
        supplier_id: [],
        project_id: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    supplierFilter: null,
    projectFilter: null
  }),
  computed: {
    ...mapGetters(['purchaseOrders', 'catalog', 'pagination', 'filterParams', 'supplierContacts', 'suppliersFilter', 'projectsFilter'])
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadRecords',
      'loadCatalog',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'setModalSummaryVisible',
      'setSendPurchaseOrderModalVisible',
      'setCancelPurchaseOrderModalVisible',
      'loadSupplierContacts',
      'loadSuppliersFilter',
      'loadProjectsFilter'
    ]),
    setActionRecord (record, action) {
      record.id && this.actionRecord({ id: record.id, action })
    },
    detailsPurchase (record) {
      this.form = record
      this.setModalSummaryVisible(true)
    },
    onReceptions (record) {
      this.$router.push({ path: `/warehouse-receptions/${record.folio}/purchase` })
    },
    async showSendPurchaseOrderModal (record) {
      await this.loadSupplierContacts(record.supplier.id)
      this.supplierContacts.push(record.supplier)
      this.form = { purchaseOrder: record, emails: this.supplierContacts }
      this.setSendPurchaseOrderModalVisible(true)
    },
    async showCancelPurchaseOrderModal (record) {
      await this.loadSupplierContacts(record.supplier.id)
      this.supplierContacts.push(record.supplier)
      this.form = { purchaseOrder: record, emails: this.supplierContacts }
      this.setCancelPurchaseOrderModalVisible(true)
    },
    setSupplier (item) {
      this.supplierFilter = item.name
      this.filters.whereIn.supplier_id.push(item.id)
    },
    searchSupplier (value) {
      this.loadSuppliersFilter({ page: 1, filters: `&param=${value},name` })
    },
    deselectSupplier () {
      this.searchSupplier('')
      this.supplierFilter = null
      this.filters.whereIn.supplier_id.clear()
    },
    setProject (item) {
      this.projectFilter = item.name
      this.filters.whereIn.project_id.push(item.id)
    },
    searchProject (value) {
      this.loadProjectsFilter({ page: 1, filters: `&param=${value},name` })
    },
    deselecProject () {
      this.searchProject('')
      this.projectFilter = null
      this.filters.whereIn.project_id.clear()
    },
    eraseFilters () {
      this.projectFilter = null
      this.supplierFilter = null
      this.clearFilter()
    }
  }
}
</script>

<style lang="scss">

.filter_type_ahead {
  margin-left: '5%';
  background: 'red'
}

.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}

</style>
